(function () {
  if (!document.body.classList.contains("template-product")) return;

  var bar = document.querySelector("sticky-add-cart.sticky-add-cart");
  var atc = document.querySelector("#ProductSubmitButton-template--30350544208204__main")
    || document.querySelector(".main-product .product-form__submit");
  var footer = document.querySelector("footer.footer")
    || document.querySelector("#shopify-section-sections--30350543323468__footer")
    || document.querySelector(".shopify-section-group-footer-group");
  if (bar && atc) {
    function sync() {
      var past = atc.getBoundingClientRect().bottom < 80;
      var atFooter = false;
      if (footer) {
        atFooter = footer.getBoundingClientRect().top < window.innerHeight - 8;
      }
      var show = past && !atFooter;
      bar.classList.toggle("is-visible", show);
      bar.classList.toggle("show-sticky-cart", show);
    }
    sync();
    window.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
  }

  document.addEventListener(
    "error",
    function (event) {
      var el = event.target;
      if (!el || el.tagName !== "IMG") return;
      if (el.dataset.missingHandled) return;
      el.dataset.missingHandled = "1";
      var ph = document.createElement("div");
      ph.className = "qurtens-missing-media";
      ph.textContent = "missing image";
      if (el.parentNode) el.parentNode.replaceChild(ph, el);
    },
    true
  );

  function openCartDrawer() {
    if (typeof window.upcartOpenCart === "function") {
      window.upcartOpenCart();
      return;
    }
    if (typeof window.upcartRefreshCart === "function") {
      window.upcartRefreshCart();
    }
    var icon = document.getElementById("cart-icon-bubble")
      || document.getElementById("cart-icon-bubble-mobile");
    if (icon) {
      icon.click();
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || "/cart";
  }

  function showAtcError(form, message) {
    var wrap = form.closest(".product-form, product-form");
    var box = wrap && wrap.querySelector(".product-form__error-message-wrapper");
    var text = box && box.querySelector(".product-form__error-message");
    if (box && text) {
      text.textContent = message || "Could not add to cart.";
      box.hidden = false;
      return;
    }
    window.alert(message || "Could not add to cart.");
  }

  function headerOverlap() {
    var header = document.querySelector(".section-header")
      || document.querySelector(".site-header")
      || document.querySelector("sticky-header")
      || document.querySelector("#shopify-section-header");
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    if (rect.bottom <= 0) return 0;
    var pos = window.getComputedStyle(header).position;
    if (pos !== "fixed" && pos !== "sticky") return 0;
    return Math.max(0, rect.height);
  }

  function scrollToBuyBox() {
    var heading = document.querySelector(".block-product__title h1.title")
      || document.querySelector(".block-product__title h1")
      || document.querySelector("#shopify-block-AUW80YkFkeEMwTVczb__title_product_JVDjeh");
    if (!heading) return;
    var extra = 20;
    var top = window.pageYOffset + heading.getBoundingClientRect().top - headerOverlap() - extra;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  document.addEventListener(
    "click",
    function (event) {
      var btn = event.target.closest
        ? event.target.closest("[data-scroll-to-cart], #ProductSubmitButton-template--30350544208204__main-sticky-add-cart")
        : null;
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      scrollToBuyBox();
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute("data-type") !== "add-to-cart-form") return;
      if (form.id && form.id.indexOf("installment") !== -1) return;
      if (form.classList.contains("form-sticky-add-cart")) return;
      if (form.id && form.id.indexOf("sticky") !== -1) return;

      var btn = form.querySelector('button[name="add"], .product-form__submit, [type="submit"]');
      if (btn && (btn.disabled || btn.getAttribute("aria-disabled") === "true")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) {
        showAtcError(form, "Select a size first.");
        return;
      }

      if (btn) {
        btn.setAttribute("aria-disabled", "true");
        btn.classList.add("loading");
      }

      var addUrl = (window.routes && window.routes.cart_add_url) || "/cart/add.js";
      fetch(addUrl, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
        credentials: "same-origin"
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          var data = result.data || {};
          if (!result.ok || data.status) {
            showAtcError(form, data.description || data.message || "Could not add to cart.");
            return;
          }
          if (typeof window.upcartRefreshCart === "function") window.upcartRefreshCart();
          openCartDrawer();
        })
        .catch(function () {
          showAtcError(form, "Could not add to cart.");
        })
        .finally(function () {
          if (!btn) return;
          btn.classList.remove("loading");
          btn.removeAttribute("aria-disabled");
        });
    },
    true
  );
})();
